<div class="close-button">
  <button tabIndex="-1" class="" mat-icon-button (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<h1 mat-dialog-title>{{ data.notification.title }}</h1>
<mat-dialog-content class="mat-mdc-dialog-content mdc-dialog__content">
  <div class="mb-4 leading-[16px] text-black">
    {{ data.notification.message }}
  </div>
  <div class="grid-container">
    @if (data.notification?.subject) {
      <div class="font-bold text-black">Subject:</div>
      <div>{{ data.notification.subject }}</div>
    }
    @if (data.notification?.to) {
      <div class="font-bold text-black">To:</div>
      <div>{{ data.notification.to }}</div>
    }
    @if (data.notification?.attachments) {
      <div class="font-bold text-black">Attachments:</div>
      <div>{{ data.notification.attachments?.join(', ') }}</div>
    }
  </div>
  @if (data.notification?.html) {
    <div class="relative mt-4 overflow-x-auto">
      <pre
        class="break-all rounded bg-sidenav p-4"><code class="break-all">{{ data.notification.html }}</code></pre>
      <mat-icon
        (click)="copy()"
        class="absolute right-2 top-2 cursor-pointer text-center text-[16px]"
        [cdkCopyToClipboard]="data.notification?.html ?? ''"
        >content_copy</mat-icon
      >
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions
  class="mat-mdc-dialog-actions mdc-dialog__actions"></mat-dialog-actions>
